import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { Bot } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { AiSettingsPage } from "./pages/AiSettingsPage";

/**
 * Superuser-only system settings. Today this is the AI provider keys (Claude /
 * OpenAI) for the Reports agent; more system settings can hang off /system here.
 * Gated on the "*" (superuser) permission — matches the backend's
 * ``require_superuser`` on /api/settings/ai.
 */
export const settingsModule: FeatureModule = {
  key: "settings",
  nav: {
    label: "AI Settings",
    icon: Bot,
    to: "/system/ai-settings",
    requires: "*",
    order: 10,
    group: "System",
  },
  routes: (rootRoute) =>
    [
      createRoute({
        getParentRoute: () => rootRoute,
        path: "/system/ai-settings",
        component: guarded("*", AiSettingsPage),
      }),
    ] as unknown as AnyRoute[],
};
